
/**
 * createHtmlOptions - Recieves an array of options to be converted to HTML <option> tags
 *
 * @param {array} options, an array of options to be converted to HTML <option> tags
 * @return {string} HTML option tags string.
 *
 * Used in 'spare-parts-form.liquid'
**/
const createHtmlOptions = (options) => {
  let htmlOptions = '';
  options.forEach((item) => htmlOptions += `<option>${item}</option>`);
  return htmlOptions;
}


/**
 * base64 - Returns the received file in base64 format.
 *
 * @param {file} file, A file input element value.
 * @return {string} base64 file string.
 *
 * Used in 'contact-landing2.liquid' (Custom match page - contact form)
**/
const base64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => reject(error);
  });
}


function send_to_s3(file, outputSelector, submitSelector) {
    var date = new Date();  
    var reader = new FileReader();
    reader.onload = function(){
      var arrayBuffer = this.result,
      array = new Uint8Array(arrayBuffer);
      $.ajax({
        url: 'https://ronit-furst.s3.us-east-2.amazonaws.com/'+ encodeURIComponent(file.name),
        type: 'PUT',
        data:arrayBuffer,
        processData: false,
        contentType: false,
        success: function (data) {
          console.info(data);
          $(outputSelector).val("https://ronit-furst.s3.us-east-2.amazonaws.com/" + encodeURIComponent(file.name));
        },
        fail: function(data) {
          alert( "error" );
        },
        complete: function(data){
           $(submitSelector).removeAttr("disabled");
        }
      });
 	}  
    reader.readAsArrayBuffer(file);
  } 

/**
 * handleWsDisplay - Handles the Gorilla app's Wholesale prices display according to the custom header select fields.
 *
 * @param {string} id, The id of the Wholesale select element.
 * @param {string} template, The Liquid template (e.g collection, product, index etc.).
 * @param {string} currency, The shop's currency (Liquid shop.currency).
 * @return {void}.
 *
 * Used in 'custom-ws-desktop.liquid' and 'custom-ws-mobile.liquid'
**/
const handleWsDisplay = (id, template, currency) => {
    const wsDisplay = localStorage.getItem('wholesale-display');
    if(wsDisplay) {
      $(`select#${id} > option:selected`).attr('selected', false);
      $($(`select#${id}`)[0][wsDisplay]).attr('selected', true);

      switch (wsDisplay) {
        case '0': 
          $('.LaaPriceWrap')
          	.addClass(template == 'collection' || template == 'index' ? 'grid-product__price' : 'product__price')
            .removeClass('hide');
          break;
        case '1': 
          $('.LaaPriceWrap').removeClass('hide');
          break;
        case '2': 
          $('head').append('<style>.wsgRetailPrice{display:none}</style>');
          $('.LaaPriceWrap').addClass(template == 'collection' || template == 'index' ? 'grid-product__price' : 'product__price');
          $('.LaaPriceWrap').removeClass('hide');
          break;
      }
    } else {
      localStorage.setItem('wholesale-display', $(`select#${id}`).prop('selectedIndex'));
    }

    $(`select#${id}`).change(() => {
      localStorage.setItem('wholesale-display', $(`select#${id}`).prop('selectedIndex'));
      window.location.reload();
    });
}